import React from "react";
import { motion } from "framer-motion";

export const BRAND = "#0052FF";

export const btnPrimary =
  "inline-flex items-center justify-center gap-2 rounded-full bg-[#0052FF] px-6 py-3 text-sm font-medium text-white transition-colors duration-200 hover:bg-[#0043D1] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#0052FF] focus-visible:ring-offset-2 shadow-[0_10px_30px_-8px_rgba(0,82,255,0.5)]";

export const btnSecondary =
  "inline-flex items-center justify-center gap-2 rounded-full bg-white px-6 py-3 text-sm font-medium text-[#0A1128] border border-slate-200 transition-colors duration-200 hover:bg-slate-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-slate-200 focus-visible:ring-offset-2";

export const cardBase =
  "bg-white rounded-2xl ring-1 ring-inset ring-slate-900/[0.06] shadow-[0_8px_30px_rgb(0,0,0,0.04)]";

export const easeOut = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 24, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.6, ease: easeOut, delay }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, className = "" }) => (
  <span
    className={`font-mono-ui text-[11px] font-semibold uppercase tracking-[0.2em] text-[#0052FF] ${className}`}
  >
    {children}
  </span>
);

export const SectionHeading = ({ eyebrow, title, subtitle, align = "left" }) => (
  <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
    <h2 className="font-display mt-4 text-3xl font-bold tracking-tight text-[#0A1128] sm:text-4xl lg:text-[2.75rem] lg:leading-[1.1]">
      {title}
    </h2>
    {subtitle && (
      <p
        className={`mt-5 text-base leading-relaxed text-[#64748B] sm:text-lg ${
          align === "center" ? "mx-auto max-w-2xl" : "max-w-2xl"
        }`}
      >
        {subtitle}
      </p>
    )}
  </div>
);
